/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFilterFunnelIcon16Light } from './UiFilterFunnelIcon16Light';
import { UiFilterFunnelIcon16Regular } from './UiFilterFunnelIcon16Regular';
import { UiFilterFunnelIcon16Solid } from './UiFilterFunnelIcon16Solid';
import { UiFilterFunnelIcon20Light } from './UiFilterFunnelIcon20Light';
import { UiFilterFunnelIcon20Regular } from './UiFilterFunnelIcon20Regular';
import { UiFilterFunnelIcon20Solid } from './UiFilterFunnelIcon20Solid';
import { UiFilterFunnelIcon24Regular } from './UiFilterFunnelIcon24Regular';
import { UiFilterFunnelIcon24Solid } from './UiFilterFunnelIcon24Solid';
import { UiFilterFunnelIcon32Regular } from './UiFilterFunnelIcon32Regular';
import { UiFilterFunnelIcon64Regular } from './UiFilterFunnelIcon64Regular';
var sizes = {
    16: {
        light: UiFilterFunnelIcon16Light,
        regular: UiFilterFunnelIcon16Regular,
        solid: UiFilterFunnelIcon16Solid,
    },
    20: {
        light: UiFilterFunnelIcon20Light,
        regular: UiFilterFunnelIcon20Regular,
        solid: UiFilterFunnelIcon20Solid,
    },
    24: {
        regular: UiFilterFunnelIcon24Regular,
        solid: UiFilterFunnelIcon24Solid,
    },
    32: {
        regular: UiFilterFunnelIcon32Regular,
    },
    64: {
        regular: UiFilterFunnelIcon64Regular,
    },
};
export var UiFilterFunnelIcon = forwardRef('UiFilterFunnelIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
